export const LAST_UPDATED = "2026-06-10";
export const LAST_UPDATED_FR = "10 juin 2026";
